import { DrawCustomModeThis, DrawFeature, DrawLineString, DrawPoint } from "@mapbox/mapbox-gl-draw";

import { ValidationState } from "fond/draw/validation/helper";
import { EditingLayer } from "fond/types";

import { deleteAndValidate, getLineEndpointPoints, NetworkTopologyConfig } from "../topologyHelper";

/**
 * Makes the underground delete handler.
 *
 * Key difference from aerial: deleting a point does NOT cascade to connected paths.
 * The point is simply removed and paths remain in place (they may become disconnected).
 *
 * Deleting a path leaves its endpoint points in place but refreshes their snapped status.
 *
 * Designed to be used as an EditingLayer.onTrash callback.
 */
export const makeOnTrashUnderground = (config: NetworkTopologyConfig): NonNullable<EditingLayer["onTrash"]> =>
  function onTrashUnderground(this: DrawCustomModeThis, features: DrawFeature[], state: ValidationState): void {
    const deleteIds: (string | number)[] = [];
    const pointsToRefresh: DrawPoint[] = [];

    features.forEach((feature) => {
      if (feature.id != null) {
        deleteIds.push(feature.id);
      }

      if (feature.type === "Point") {
        // NO cascade — just delete the point, leave connected paths intact.
        // This is the key behavioral difference from onTrashAerial.
      } else if (feature.type === "LineString") {
        // When deleting a path, refresh snapped status of endpoint points
        pointsToRefresh.push(...getLineEndpointPoints.call(this, config.underground, feature as DrawLineString));
      }
    });

    deleteAndValidate.call(this, config.underground, state, deleteIds, pointsToRefresh);
  };
